import { template as template_4e19ef0dbb3a4a478b0c71d0b208ead1 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import type RenderErrorStateService from '../../services/render-error-state';
interface Signature {
    Args: {
        model?: {
            reason: string;
        };
    };
}
class RenderErrorRouteComponent extends Component<Signature> {
    // The render route handles errors before the child route activates, so we read
    // the serialized payload from the shared service instead of relying on params.
    @service
    renderErrorState: RenderErrorStateService;
    get reason() {
        return this.renderErrorState.reason ?? this.args.model?.reason ?? '';
    }
    static{
        template_4e19ef0dbb3a4a478b0c71d0b208ead1(`
    <pre
      data-prerender-error
      data-prerender-id={{this.renderErrorState.cardId}}
      data-prerender-nonce={{this.renderErrorState.nonce}}
    >
      {{this.reason}}
    </pre>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default RouteTemplate(RenderErrorRouteComponent);
